import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { DateInput } from 'atoms/date-input';
import Dropdown from 'atoms/dropdown';
import Icon from 'atoms/icon';
import { getTimeFromDate, openHourOptions, prettifyHour } from 'util';

export function OverrideRanges({
  isPlaceholder,
  date,
  start,
  end,
  uuid,
  onSelectDate,
  onSelectTime,
  onRemoveDate,
  inSingleDayPanel,
}) {
  const { hours } = useSelector((state) => state.provider.locations[0]);
  if (!isPlaceholder) {
    return (
      <div className="flex-row w-100">
        {!inSingleDayPanel && (
          <DateInput
            size="small"
            className="override-range-date mr-10"
            value={start}
            readOnly
          />
        )}
        <div
          className={classNames(
            'border-light-purple radius-12 f13 override-range-input mr-10',
            inSingleDayPanel && 'w-100'
          )}
        >
          {prettifyHour(getTimeFromDate(start))}
        </div>
        {inSingleDayPanel && <p className="f13 mr-10">to</p>}
        <div
          className={classNames(
            'border-light-purple radius-12 f13 override-range-input',
            inSingleDayPanel && 'w-100'
          )}
        >
          {prettifyHour(getTimeFromDate(end))}
        </div>
        <Icon
          name="bin"
          className="pointer ml-10"
          onClick={() => onRemoveDate(uuid, isPlaceholder)}
        />
      </div>
    );
  }
  return (
    <div className="flex-row">
      {!inSingleDayPanel && (
        <DateInput
          size="small"
          className="mr-10"
          value={start}
          onChange={(value) => onSelectDate(value, uuid)}
          placeholder="Select date"
          disablePast
        />
      )}
      <Dropdown
        size="small"
        variant="white"
        className={classNames('mr-10', inSingleDayPanel && 'w-100')}
        placeholder="Start time"
        items={openHourOptions(date, hours)}
        onClick={({ valueFormatted }) =>
          onSelectTime({ date, start: valueFormatted, end, uuid })
        }
        value={prettifyHour(getTimeFromDate(start))}
        readOnly={!date}
        hideIcon={!date}
      />
      {inSingleDayPanel && <p className="f13 mr-10">to</p>}
      <Dropdown
        size="small"
        variant="white"
        className={classNames(inSingleDayPanel && 'w-100')}
        placeholder="End time"
        items={openHourOptions(date, hours, getTimeFromDate(start))}
        onClick={({ valueFormatted }) =>
          onSelectTime({ date, end: valueFormatted, start, uuid })
        }
        value={prettifyHour(getTimeFromDate(end))}
        readOnly={!date}
        hideIcon={!date}
      />
      <Icon
        name="bin"
        className="pointer ml-10"
        onClick={() => onRemoveDate(uuid, isPlaceholder)}
      />
    </div>
  );
}
